import type { Commerce } from '@interfaces/general';

export const sanitizePhone = (value: string): string => value.replace(/\D/g, '');

// Muchos comercios legado tienen `telefono` guardado como string en el backend y el GET
// /v1/comercio lo devuelve tal cual, pero el schema del PUT exige number: re-enviar el objeto
// leído produce 400 INVALID_SCHEMA en toda pantalla que guarda el comercio completo (horarios,
// cierre temporal, ajustes…). El tipo TS (`telefono?: number`) no protege en runtime, así que se
// normaliza en la frontera GET→estado; cada guardado exitoso persiste el dato ya sano.
export const normalizeCommerceTelefono = (commerce: Commerce): Commerce => {
  const telefono: unknown = commerce.telefono;
  if (typeof telefono !== 'string') return commerce;
  const digits = sanitizePhone(telefono);
  const parsed = Number(digits);
  // isSafeInteger descarta strings tan largos que perderían precisión al volverse number
  // (E.164 tope 15 dígitos, siempre representable): mejor undefined que persistir basura alterada.
  return { ...commerce, telefono: digits && Number.isSafeInteger(parsed) ? parsed : undefined };
};

export const isValidPhone = (phone: string): boolean => {
  const digits = sanitizePhone(phone);
  return digits.length === 10;
};

export const PHONE_HELP_TEXT = 'Ingresa los 10 dígitos sin espacios ni código de país. Ej: 9933221100';

export const formatPhoneInput = (value: string): string => {
  return sanitizePhone(value).slice(0, 10);
};
